<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" :to="dashboard">
        <img class="navbar-brand-full" :src="custom.image || 'img/F1-uwss.png'" width="89" height="25">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
        <b-navbar-nav class="d-md-down-none">
          <b-nav-item class="px-3" :to="dashboard"><b style="color:#3D63BA">Integrate</b><b style="color:black"><br>Dashboard</b></b-nav-item>
          <b-nav-item class="px-3" to="/management/signup"><b style="color:#3D63BA">Management</b><b style="color:black; font-size:10px"><br>(User, Billing)</b></b-nav-item>
          <!-- <b-nav-item class="px-3" to="/webcastle"><b style="color:#3D63BA">WEBCastle</b><b style="color:black; font-size:10px"><br>(Web Application Firewall)</b></b-nav-item>
          <b-nav-item class="px-3" to="/wsfinder"><b style="color:#3D63BA">WSFinder</b><b style="color:black; font-size:10px"><br>(WebShell Detection System)</b></b-nav-item>
          <b-nav-item class="px-3" to="/wmds"><b style="color:#3D63BA">WMDS</b><b style="color:black; font-size:10px"><br>(Web Malware Detection System)</b></b-nav-item>
          <b-nav-item class="px-3" to="/integrity"><b style="color:#3D63BA">WFDetector</b><b style="color:black; font-size:10px"><br>(Web Forgery Detection System)</b></b-nav-item> -->
          <b-nav-item class="px-3" to="/board"><b style="color:black">Service Info</b><b style="color:black; font-size:10px"><br>(Board)</b></b-nav-item>
          <!-- <b-nav-item class="px-3" @click="menual()"><b style="color:black">Manual</b></b-nav-item> -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
        <b-nav-item @click="toggle" style="margin-right: 25px;">
          <i class="fa fa-clock-o" :class="{ 'text-secondary' : pause }" title="toggle auto logout"></i>
          <b-badge v-if="stale" pill :variant="pause ? 'secondary' : 'success'" >{{stale}}</b-badge>
        </b-nav-item>
        <b-nav-item @click="logout()" style="margin-right: 30px;">
          <i class="fa fa-sign-out" title="logout" @click="logout()"></i>
          <b-badge variant="white">logout</b-badge>
        </b-nav-item>
      </b-navbar-nav>

    </AppHeader>
    <div class="app-body pull-right" >
      <AppSidebar fixed ref="_list">
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"> </SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>

      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div>
        <div v-if="is_custom">
          -
        </div>
        <div v-else>
          <a href="http://www.f1security.co.kr">F1Security Inc.</a>
          <span>234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
        </div>
      </div>
      <div class="ml-auto">
        <span>Copyright 2019. F1Security Inc. All right reserved.</span>
      </div>
    </TheFooter>
  </div>
</template>


<script>

// import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import { auth, idle, signalr, custom } from '@/service';
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import _ from 'lodash'
import config from '@/config'


// https://fontawesome.com/v4.7.0/cheatsheet/
let all_nav =  [

  // dashboard
  { name: 'Integrate', url: '/dashboard', icon: 'cui-dashboard' , permission : ['owner', 'manager', 'monitor']},
  { name: 'Integrate', url: '/dashboard_sales', icon: 'cui-dashboard' , permission : ['sales']}, // 총판용 화면 따로 필요

  // management
  { name: 'Management', url : '/management', permission : ['sales', 'owner', 'manager', 'monitor'], icon: 'fa fa-users', children : [
    { name: 'Manager', url: '/management/admin', icon: 'icon-people', permission : ['owner']},
    { name: 'Partner', url: '/management/partner', icon: 'icon-people', permission : ['sales', 'owner', 'manager', 'monitor']},
    { name: 'Group', url: '/management/group', icon: 'icon-folder' , permission : ['sales', 'owner', 'manager', 'monitor']},
    { name: 'User', url: '/management/user', icon: 'icon-people', permission : ['sales', 'owner', 'manager', 'monitor']},
    { name: 'Signup', url: '/management/signup', icon: 'icon-people', permission : ['owner', 'manager', 'monitor']},
    { name: 'Signout', url: '/management/signout', icon: 'icon-people', permission : ['owner', 'manager', 'monitor']},
  ]},

  // billing
  { name: 'Billing' , permission : ['owner', 'manager', 'monitor'], icon: 'fa fa-credit-card-alt', children: [
    { name: 'Invoices Partner', url: '/billing/invoice_partner', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
    { name: 'Invoices Group', url: '/billing/invoice_group', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
    { name: 'Payment', url: '/billing/payment', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
    // { name: 'Credit', url: '/history/credit', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
  ]},

  // start solution area
  { name: 'Solution', title : true , permission : ['owner', 'manager', 'monitor']},

  // webcastle
  { name: 'WEBCastle', url : '/webcastle', icon: 'fa fa-list-alt', permission : ['owner', 'manager', 'monitor'], children : [
    { name: 'Dashboard', url: '/webcastle/dashboard', icon: 'cui-dashboard' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Server List', url: '/webcastle/modules', icon: 'icon-rocket' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Log', url: '/webcastle/log', icon: 'icon-magnifier-add' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Policy', url: '/webcastle/policy', icon: 'icon-magnifier-add' , permission : ['owner', 'manager']},
  ] },

  // WSFinder
  { name: 'WSFinder', url: '/wsfinder',  icon: 'fa fa-list-alt', permission : ['owner', 'manager', 'monitor'], children: [
    { name: 'Dashboard', url: '/wsfinder/dashboard', icon: 'cui-dashboard' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Agent', url: '/wsfinder/agent', icon: 'icon-ghost' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Detect', url: '/wsfinder/detect', icon: 'icon-magnifier-add' , permission : ['owner', 'manager', 'monitor']},
    { name: 'System Pattern', url: '/wsfinder/spattern', icon: 'icon-paypal' , permission : ['owner', 'manager', 'monitor']},
    { name: 'User Pattern', url: '/wsfinder/upattern', icon: 'icon-paypal' , permission : ['owner', 'manager', 'monitor']},
    { name: 'WebShell List', url: '/wsfinder/webshell', icon: 'icon-list' , permission : ['owner', 'manager', 'monitor']},
    { name: 'WebShell Upload', url: '/wsfinder/regist', icon: 'icon-cloud-upload' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Submitted WebShell', url: '/wsfinder/submitted', icon: 'icon-loop' , permission : ['owner', 'manager', 'monitor']},
  ] },

  // WMDS
  { name: 'WMDS', url : '/wmds', icon: 'fa fa-list-alt', permission : ['owner', 'manager', 'monitor'], children : [
    { name: 'Dashboard', url: '/wmds/dashboard', icon: 'cui-dashboard' , permission : ['owner', 'manager', 'monitor']},

    { name: 'Site', url: '/wmds/site', icon: 'fa fa-gg-circle' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Schedule', url: '/wmds/schedule', icon: 'fa fa-clock-o' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Policy', url: '/wmds/policy', icon: 'fa fa-list-alt' , permission : ['owner', 'manager', 'monitor']},

    { name: 'Result', url: '/wmds/result', icon: 'icon-check' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Detect', url: '/wmds/detect', icon: 'icon-magnifier-add' , permission : ['owner', 'manager', 'monitor']},

    { name: 'System Pattern', url: '/wmds/spattern', icon: 'icon-paypal' , permission : ['owner', 'manager', 'monitor']},
    { name: 'User Pattern', url: '/wmds/upattern', icon: 'icon-paypal' , permission : ['owner', 'manager', 'monitor']},
  ] },

  // integrity
  { name: 'WFDetector', url: '/integrity', icon: 'fa fa-list-alt', permission : ['owner', 'manager', 'monitor'], children : [
    { name: 'Main', url: '/integrity/main'  , icon: 'icon-info', permission : ['owner', 'manager', 'monitor']},
    { name: 'Detect', url: '/integrity/detect', icon: 'icon-check', permission : ['owner', 'manager', 'monitor']},
  ] },

  // board
  { name: 'Board', title : true , permission : ['owner', 'manager', 'monitor']},
  { name: 'Board', url:'/board', icon: 'fa fa-list-alt', permission : ['owner', 'manager', 'monitor'], children : [
    { name: 'Main', url: '/board/main', icon: 'cui-dashboard' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Notice', url: '/board/notice', icon: 'icon-bell' , permission : ['owner', 'manager', 'monitor']},
    { name: 'FAQ', url: '/board/faq', icon: 'icon-bulb' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Q & A', url: '/board/qna', icon: 'icon-question' , permission : ['owner', 'manager', 'monitor']},
  ] },

  // log
  { name: 'Audit', title : true , permission : ['owner', 'manager', 'monitor']},
  { name: 'Log', url: '/log', icon: 'icon-layers',  permission : ['owner', 'manager', 'monitor'], children : [
    { name: 'Login', url: '/log/login', icon: 'icon-layers' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Auth', url: '/log/auth', icon: 'icon-layers' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Action', url: '/log/action', icon: 'icon-layers' , permission : ['owner', 'manager', 'monitor']},
    { name: 'System', url: '/log/system', icon: 'icon-layers' , permission : ['owner', 'manager', 'monitor']},
    { name: 'Mail', url: '/log/mail', icon: 'icon-layers' , permission : ['owner', 'manager', 'monitor']},
    // log with billing
    { name: 'Install', url: '/history/install', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
    { name: 'Credit', url: '/history/credit', icon: 'fa fa-credit-card-alt', permission : ['owner', 'manager', 'monitor']},
  ]},

  { name: 'System', title : true , permission : ['owner']},
  { name: 'Setting', url: '/system/setting', icon: 'icon-wrench', permission : ['owner']},
  { name: 'Mail', url: '/system/mail', icon: 'fa fa-list-alt', permission : ['owner']},
]

// let check_permit = vs => _.filter(vs, v => {
//   if(!auth.has_level(v.level)) { return undefined; }
//   if(_.isArray(v.children)) { v.children = check_permit(v.children); }
//   return v;
// });

export default {
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  // data: () => ({ nav: check_permit(links), pause: false, stale: undefined, stale_check : undefined }),
  data: () => {
    return {
      dashboard : '',
      custom : custom.custom_default,
      // all_nav : all_nav,
      auth : undefined,
      // nav: all_nav,
      base_href : `${location.protocol}//${location.host}`,
      b : undefined,
      pause: false,
      // location : 'wmds',
      service : '',
      stale: undefined,
      stale_check : undefined,
    }
  },
  computed: {
    is_custom() {
      return this.custom.slogan && this.custom.slogan.toUpperCase().indexOf('F1-UWSS') < 0
    },
    menual() { return window.open(`https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`) },
    name() { return this.$route.name },
    list() { return this.$route.matched },
    nav() { return _.filter(all_nav, r => {
      if(_.indexOf(r.permission, auth.profile.permissions) == -1) { return undefined }
      r.children = r.children ? _.filter(r.children, s => _.indexOf(s.permission, auth.profile.permissions) > -1 ) : undefined
      return r
    })}
  },
  methods: {
    redir($event, rs) { console.log("redir", $event, rs) },
    toggle() { this.pause = !this.pause; this.pause ? idle.pause() : idle.resume(); },
    logout() { auth.logout(); this.$router.push('/auth/login') },
    location() { return location.hash.split('/')[1] }
  },
  created: function() {
    this.dashboard = auth.profile && auth.profile.permissions && !auth.profile.permissions.startsWith('sales') ? 'dashboard' : 'dashboard_sales'
    this.custom = custom.setting()
    console.log(auth.profile)
    console.log('[vue] private container', 'created');
    console.log(custom.image, "custom.image")

    idle.start(this.logout, 15).keepalive(auth.refresh, 300);
    signalr.start('ws')
      .on('msg', m => this.$toastr.s(m.body ? m.body : m, 'Message'))
      .on('emsg', m => this.$toastr.w(m.body ? m.body : m, 'Message'))
      .on('err', m => console.error(m))
      .on('error', m => console.error(m))
      .on('logout', m => { this.$toastr.s(m.body ? m.body : m, 'Message'); this.logout(); })
      // 매니저는 사용하지 않음
      // .on('wmds', m => signalr.publish('wmds', m))
      // .on('wsfinder', m => signalr.publish('wsfinder', m))
      .on('webcastle', m => signalr.publish('webcastle', m));
    this.stale_check = setInterval(() => {
      if(idle.p) { return this.stale = '∞'; }
      let ts = parseInt((idle.stale - new Date().getTime()) / 1000);
      if(ts > 300) { return this.stale = '+5:00'; } // 5분 이내는 신경쓰지 않음.
      let m = (parseInt(ts / 60)).toString();
      let s = (parseInt(ts % 60) + 100).toString().substr(1,2);
      return this.stale = `${m}:${s}`;
    }, 1000);
  },
  destroyed: function() {
    console.log('[vue] private container', 'destroyed');
    signalr.stop();
    idle.stop();
    clearInterval(this.stale_check);
  },
  mounted: function() { console.log('[vue] private container', 'mounted'); },
}
</script>
